export class Types {
  public static Attraction = 'Attraction';
  public static User = 'User';
  public static Walk = 'Walk';
  public static Restaurant = 'Restaurant';
  public static Accommodation = 'Accommodation';
  public static LifeStyle = 'LifeStyle';
  public static Favourite = 'Favourite';
  public static Walked = 'Walked';
  public static Share = 'Share';
  public static Information = 'Information';
  public static Tour = 'Tour';
  public static AppInfo = 'AppInfo';
  public static Shopping = 'Shopping';
  public static New = 'news';
  public static AppNew = 'news';
  public static Event = 'Event';
  public static Coupon = 'Coupon';
  public static Settings = 'settings';
}
